/** 
 *  ==========================
 *  BLOCK: Icon Block
 *  ==========================
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import {
    disabledBlocks, i18n 
} from 'cartzillagb'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'
import { ButtonIcon } from '~cartzillagb/icons'
import { createButtonAttributes } from '~cartzillagb/util'

export const schema = {
    ...createButtonAttributes( 'button1%s' ),
}

export const name = 'czgb/button'

export const settings = {
    title: __( 'Button', i18n ),
    icon: ButtonIcon,
    category: 'cartzillagb',
    example: {},
    keywords: [
        __( 'Button', i18n ),
        __( 'CartzillaGB', i18n ),
    ],
    attributes: schema,
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },

    edit,
    save,

    // CartzillaGB modules.
    modules: {
        'advanced-responsive': true,
    },
}